export default __webpack_public_path__ + "./static/icon192_maskable.png";